let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ciMQX")).then(() => parcelRequire('id7mY'));